// extracted by mini-css-extract-plugin
export var bodyCopy = "fullColumn-module--bodyCopy--e82cc";
export var bodyCopyp = "fullColumn-module--bodyCopyp--51059";
export var buttons = "fullColumn-module--buttons--d3d04";
export var eyebrow = "fullColumn-module--eyebrow--95d20";
export var fullColumnContent = "fullColumn-module--fullColumnContent--af143";
export var grid = "fullColumn-module--grid--53b3c";
export var headline = "fullColumn-module--headline--2882e";
export var image = "fullColumn-module--image--c5a12";
export var lemon = "fullColumn-module--lemon--9d7ce";
export var mainContent = "fullColumn-module--mainContent--327ca";
export var mobileImage = "fullColumn-module--mobileImage--9db7b";
export var oneColumnGrid = "fullColumn-module--oneColumnGrid--93c73";
export var poppy = "fullColumn-module--poppy--bc726";
export var schmal = "fullColumn-module--schmal--e5400";
export var textCentered = "fullColumn-module--textCentered--cb092";
export var textLeft = "fullColumn-module--textLeft--51ca0";
export var textRight = "fullColumn-module--textRight--be263";